import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, unref as _unref, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "p-recommend-inner -is-form" }
const _hoisted_2 = { class: "p-recommend-form__field" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h2", { class: "p-recommend-form__title" }, [
  /*#__PURE__*/_createElementVNode("span", null, "最終学歴")
], -1)
const _hoisted_4 = { class: "p-recommend-form__error-wrap" }
const _hoisted_5 = { class: "p-recommend-form__group-1 --type-2" }
const _hoisted_6 = { class: "p-recommend-form__group-1-field" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { class: "p-recommend-form__text-1" }, [
  /*#__PURE__*/_createTextVNode("最終学歴"),
  /*#__PURE__*/_createElementVNode("span", { class: "-is-required" }, "必須")
], -1)
const _hoisted_8 = { class: "p-recommend-form__set-1" }
const _hoisted_9 = { class: "p-login-form__checkbox" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", {
  class: "p-recommend-form__label",
  for: "form-graduation-rikei"
}, "理系", -1)
const _hoisted_12 = { class: "p-recommend-form__field js-form-block" }
const _hoisted_13 = {
  class: "p-recommend-form__list-2 js-entry-list",
  "data-entries": "6"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("h2", { class: "p-recommend-form__heading-1" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "p-recommend-form__heading-text" }, "学歴"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-label-highlight --auto-right2" }, "履")
], -1)
const _hoisted_15 = { class: "p-recommend-form__error-wrap" }
const _hoisted_16 = { class: "p-recommend-form__group-1" }
const _hoisted_17 = { class: "p-recommend-form__group-1-field" }
const _hoisted_18 = { class: "p-recommend-form__text-1" }
const _hoisted_19 = ["onClick"]
const _hoisted_20 = { class: "p-recommend-form__group-1-block-1" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("p", { class: "p-recommend-form__text-2" }, "※高等学校、高等専門学校の入力、また検索しても見つからない場合は、学校名を直接入力してください。", -1)
const _hoisted_22 = { class: "p-recommend-form__group-1-field" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("p", { class: "p-recommend-form__text-1" }, "学部学科", -1)
const _hoisted_24 = { class: "p-recommend-form__group-1-field" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("p", { class: "p-recommend-form__text-1" }, "入学", -1)
const _hoisted_26 = { class: "p-recommend-form__group-1-block-2" }
const _hoisted_27 = { class: "p-recommend-form__group-1-block-2-col1" }
const _hoisted_28 = { class: "p-recommend-form__group-1-field" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("p", { class: "p-recommend-form__text-1" }, "卒業", -1)
const _hoisted_30 = { class: "p-recommend-form__group-1-block-2" }
const _hoisted_31 = { class: "p-recommend-form__group-1-block-2-col1" }
const _hoisted_32 = { class: "-is-select-wrap" }
const _hoisted_33 = { class: "p-recommend-form__group-1-field" }
const _hoisted_34 = ["onClick"]
const _hoisted_35 = ["onClick", "disabled"]
const _hoisted_36 = /*#__PURE__*/_createElementVNode("span", null, "学歴", -1)
const _hoisted_37 = /*#__PURE__*/_createElementVNode("span", null, "を削除する", -1)
const _hoisted_38 = [
  _hoisted_36,
  _hoisted_37
]
const _hoisted_39 = ["disabled"]
const _hoisted_40 = /*#__PURE__*/_createElementVNode("span", null, "学歴を追加する", -1)
const _hoisted_41 = [
  _hoisted_40
]
const _hoisted_42 = { class: "p-recommend-form__send-field --2-buttons" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("span", null, "前に戻る", -1)
const _hoisted_44 = [
  _hoisted_43
]
const _hoisted_45 = /*#__PURE__*/_createElementVNode("span", null, "次へ進む", -1)
const _hoisted_46 = [
  _hoisted_45
]

import ValidatableField from '@/components/ValidatableField.vue';
import ResumeSelect from '../components/ResumeSelect.vue';
import InvalidMessage from '@/components/InvalidMessage.vue';
import ResumeSearch from '../components/ResumeSearch.vue';
import YearMonthSelect from '../components/YearMonthSelect.vue';
import SchoolModal from './SchoolModal.vue';
import QuickViewModal from './QuickViewModal.vue';
import { inject, ref, watch } from 'vue';
import { CareerResumeInfoDetail, SchoolCareerDetail } from '@/types';
import { useFieldValue, useFormValues, ValidationResult } from 'vee-validate';

type Props = {
  activeTab: string;
  careerData?: CareerResumeInfoDetail;
  setFieldValue: <T extends string>(field: T, value: any, opts?: any) => void;
  validateField: (field: string) => Promise<ValidationResult>;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'EducationForm',
  props: {
    activeTab: null,
    careerData: null,
    setFieldValue: null,
    validateField: null
  },
  setup(__props: any) {

const props = __props as {
  activeTab: string;
  careerData?: CareerResumeInfoDetail;
  setFieldValue: <T extends string>(field: T, value: any, opts?: any) => void;
  validateField: (field: string) => Promise<ValidationResult>;
}

const MAX_SCHLS = 6;

const targetYearSelect = ref('');



const switchTabAndValidateFn = inject<(tabId: string) => void>('switchTabAndValidate');

const isSchoolModalOpen = ref(false);
const isQuickViewModalOpen = ref(false);

const schlCount = ref(0);
const listSchls = ref<number[]>([]);
const schlcrDetails = ref<SchoolCareerDetail[]>([]);

const toEmpty = (v: any) => v ? v : '';
const values = useFormValues();

const minYearSelect = ref<number>(0);
const maxYearSelect = ref<number>(0);
const birthDateYValue = useFieldValue('birthDateY');
watch(birthDateYValue, (newVal: any) => {
  if (newVal) {
    minYearSelect.value = newVal + 13;
    maxYearSelect.value = newVal + 100;
  }
});

function setYear(year: number) {
  props.setFieldValue(targetYearSelect.value, year);
}

function addSchl() {
  if (listSchls.value.length >= MAX_SCHLS) return;
  listSchls.value.push(Math.random());
  clearLastRecord(listSchls.value.length - 1);
}
async function removeSchl(idx: number) {
  if (listSchls.value.length > 1) {
    // Remove the item from listSchls
    // replace new values
    const len = listSchls.value.length;
    for (let i = idx; i < len - 1; i++) {
      props.setFieldValue(`schlcrDetails[${i}].schlcrId`, toEmpty(values.value.schlcrDetails[i + 1].schlcrId));
      props.setFieldValue(`schlcrDetails[${i}].schlName`, toEmpty(values.value.schlcrDetails[i + 1].schlName));
      props.setFieldValue(`schlcrDetails[${i}].schlDeptName`, toEmpty(values.value.schlcrDetails[i + 1].schlDeptName));
      props.setFieldValue(`schlcrDetails[${i}].entranceMon`, toEmpty(values.value.schlcrDetails[i + 1].entranceMon));
      props.setFieldValue(`schlcrDetails[${i}].entranceYr`, toEmpty(values.value.schlcrDetails[i + 1].entranceYr));
      props.setFieldValue(`schlcrDetails[${i}].entranceFlg`, toEmpty(values.value.schlcrDetails[i + 1].entranceFlg));
      props.setFieldValue(`schlcrDetails[${i}].gradMon`, toEmpty(values.value.schlcrDetails[i + 1].gradMon));
      props.setFieldValue(`schlcrDetails[${i}].gradYr`, toEmpty(values.value.schlcrDetails[i + 1].gradYr));
      props.setFieldValue(`schlcrDetails[${i}].gradFlg`, toEmpty(values.value.schlcrDetails[i + 1].gradFlg));
      props.setFieldValue(`schlcrDetails[${i}].schlId`, toEmpty(values.value.schlcrDetails[i + 1].schlId));
      const schlText = document.querySelector(`[name="schlcrDetails[${i}].schlId_text$"]`) as HTMLInputElement;
      const schlTextNext = document.querySelector(`[name="schlcrDetails[${i + 1}].schlId_text$"]`) as HTMLInputElement;
      if (schlText && schlTextNext)
      {
        schlText.value = schlTextNext.value;
      }
      await props.validateField(`schlcrDetails[${i}].schlName`);
      await props.validateField(`schlcrDetails[${i}].schlDeptName`);
      await props.validateField(`schlcrDetails[${i}].entranceMon`);
      await props.validateField(`schlcrDetails[${i}].entranceYr`);
      await props.validateField(`schlcrDetails[${i}].gradMon`);
      await props.validateField(`schlcrDetails[${i}].gradYr`);
    }
    listSchls.value.pop();
  }

}

function openQuickViewModal(target: string) {
  isQuickViewModalOpen.value = true;
  targetYearSelect.value = target;
}

function openSchoolModal() {
  isSchoolModalOpen.value = true;
  document.body.style.overflow = 'hidden';
}

watch(() => props.careerData, (newVal?: CareerResumeInfoDetail) => {
  if (newVal) {
    setFormData(newVal);
  }
});

function setFormData(formData: CareerResumeInfoDetail) {
  let formObject: Record<string, any> = {
    'lastSchoolId': toEmpty(formData.lastSchoolId),
    'scienceFlg': formData.scienceFlg,
  };

  // fill missing items
  const schools = [];
  if (formData.schlcrDetails && formData.schlcrDetails.length) {
    for (let i = 0; i < formData.schlcrDetails.length; i++) {
        schools.push(formData.schlcrDetails[i]);
    }
  }

  formObject = {...formObject, ...getFormDataFromSchls(schools)};
  schlCount.value = schools.length;
  schlcrDetails.value = [...schools];
  if (schools.length > 0) {
    listSchls.value = Array.from({length: schools.length}, () => Math.random());
  } else {
    // If no valid entries, keep at least one item
    listSchls.value = [Math.random()];
  }

  for (const key in formObject) {
    props.setFieldValue(key, formObject[key]);
  }
}

function getFormDataFromSchls(schools: SchoolCareerDetail[]) {
  const formObject: Record<string, any> = {};
  schools.forEach((schl, i) => {
    formObject[`schlcrDetails[${i}].schlcrId`] = toEmpty(schl.schlcrId);
    formObject[`schlcrDetails[${i}].schlId`] = toEmpty(schl.schlId);
    formObject[`schlcrDetails[${i}].schlName`] = toEmpty(schl.schlName);
    formObject[`schlcrDetails[${i}].schlDeptName`] = toEmpty(schl.schlDeptName);
    formObject[`schlcrDetails[${i}].entranceMon`] = toEmpty(schl.entranceMon);
    formObject[`schlcrDetails[${i}].entranceYr`] = toEmpty(schl.entranceYr);
    formObject[`schlcrDetails[${i}].entranceFlg`] = toEmpty(schl.entranceFlg);
    formObject[`schlcrDetails[${i}].gradMon`] = toEmpty(schl.gradMon);
    formObject[`schlcrDetails[${i}].gradYr`] = toEmpty(schl.gradYr);
    formObject[`schlcrDetails[${i}].gradFlg`] = toEmpty(schl.gradFlg);
  });

  return formObject;
}

function clearLastRecord(index: number)
{
  props.setFieldValue(`schlcrDetails[${index}].schlcrId`, '');
  props.setFieldValue(`schlcrDetails[${index}].schlId`, '');
  props.setFieldValue(`schlcrDetails[${index}].schlName`, '');
  props.setFieldValue(`schlcrDetails[${index}].schlDeptName`, '');
  props.setFieldValue(`schlcrDetails[${index}].entranceMon`, '');
  props.setFieldValue(`schlcrDetails[${index}].entranceYr`, '');
  props.setFieldValue(`schlcrDetails[${index}].entranceFlg`, '');
  props.setFieldValue(`schlcrDetails[${index}].gradMon`, '');
  props.setFieldValue(`schlcrDetails[${index}].gradYr`, '');
  props.setFieldValue(`schlcrDetails[${index}].gradFlg`, '');
}

function afterSearchChange(val: any, targerName: string) {
  if (val.text) {
    props.setFieldValue(targerName, '');
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    id: "education",
    class: _normalizeClass(["tab-content", { 'show': __props.activeTab === 'education' }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createVNode(InvalidMessage, { name: "lastSchoolId" })
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createVNode(ResumeSelect, {
              rules: "required",
              name: "lastSchoolId",
              label: "最終学歴",
              id: "lstschl",
              className: "p-recommend-form__select"
            }),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("span", _hoisted_9, [
                _createVNode(ValidatableField, {
                  name: "scienceFlg",
                  value: 1,
                  id: "form-graduation-rikei",
                  type: "checkbox"
                }),
                _hoisted_10
              ]),
              _hoisted_11
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("ul", _hoisted_13, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(listSchls.value, (schl, i) => {
            return (_openBlock(), _createElementBlock("li", { key: schl }, [
              _hoisted_14,
              _createElementVNode("div", _hoisted_15, [
                _createVNode(InvalidMessage, {
                  name: `schlcrDetails[${i}].schlId`
                }, null, 8, ["name"]),
                _createVNode(InvalidMessage, {
                  name: `schlcrDetails[${i}].schlName`
                }, null, 8, ["name"]),
                _createVNode(InvalidMessage, {
                  name: `schlcrDetails[${i}].schlDeptName`
                }, null, 8, ["name"]),
                _createVNode(InvalidMessage, {
                  name: `schlcrDetails[${i}].entranceMon`
                }, null, 8, ["name"]),
                _createVNode(InvalidMessage, {
                  name: `schlcrDetails[${i}].entranceYr`
                }, null, 8, ["name"]),
                _createVNode(InvalidMessage, {
                  name: `schlcrDetails[${i}].entranceFlg`
                }, null, 8, ["name"]),
                _createVNode(InvalidMessage, {
                  name: `schlcrDetails[${i}].gradMon`
                }, null, 8, ["name"]),
                _createVNode(InvalidMessage, {
                  name: `schlcrDetails[${i}].gradYr`
                }, null, 8, ["name"]),
                _createVNode(InvalidMessage, {
                  name: `schlcrDetails[${i}].gradFlg`
                }, null, 8, ["name"])
              ]),
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("p", _hoisted_18, [
                    _createTextVNode("学校名"),
                    _createElementVNode("button", {
                      class: "p-recommend-help",
                      type: "button",
                      onClick: _withModifiers(openSchoolModal, ["prevent"])
                    }, "?", 8, _hoisted_19)
                  ]),
                  _createElementVNode("div", _hoisted_20, [
                    _createVNode(ValidatableField, {
                      type: "hidden",
                      name: `schlcrDetails[${i}].schlcrId`
                    }, null, 8, ["name"]),
                    _createVNode(ResumeSearch, {
                      name: `schlcrDetails[${i}].schlId`,
                      id: "schl",
                      "after-select-change": (val) => afterSearchChange(val, `schlcrDetails[${i}].schlName`)
                    }, null, 8, ["name", "after-select-change"]),
                    _createVNode(ValidatableField, {
                      class: "p-recommend-form__input-1 --long",
                      id: "form-school-name-2",
                      type: "text",
                      rules: "max:60",
                      label: `学歴${i + 1}の学校名(テキスト)`,
                      name: `schlcrDetails[${i}].schlName`,
                      placeholder: "直接入力する場合はこちら",
                      maxlength: "60"
                    }, null, 8, ["label", "name"])
                  ]),
                  _hoisted_21
                ]),
                _createElementVNode("div", _hoisted_22, [
                  _hoisted_23,
                  _createVNode(ValidatableField, {
                    name: `schlcrDetails[${i}].schlDeptName`,
                    class: "p-recommend-form__input-1",
                    rules: "max:60",
                    label: `学歴${i + 1}の学部学科名`,
                    id: "form-school-department",
                    type: "text",
                    placeholder: "例）〇〇学部〇〇学科"
                  }, null, 8, ["name", "label"])
                ]),
                _createElementVNode("div", _hoisted_24, [
                  _hoisted_25,
                  _createElementVNode("div", _hoisted_26, [
                    _createElementVNode("div", _hoisted_27, [
                      _createVNode(YearMonthSelect, {
                        "max-year": maxYearSelect.value,
                        "min-year": minYearSelect.value,
                        label: "入学",
                        name: {month: `schlcrDetails[${i}].entranceMon`, year: `schlcrDetails[${i}].entranceYr`}
                      }, null, 8, ["max-year", "min-year", "name"])
                    ]),
                    _createVNode(ResumeSelect, {
                      "class-name": "p-recommend-form__select",
                      name: `schlcrDetails[${i}].entranceFlg`,
                      id: "entrance",
                      "empty-text": "選択"
                    }, null, 8, ["name"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_28, [
                  _hoisted_29,
                  _createElementVNode("div", _hoisted_30, [
                    _createElementVNode("div", _hoisted_31, [
                      _createVNode(YearMonthSelect, {
                        "max-year": maxYearSelect.value,
                        "min-year": minYearSelect.value,
                        label: "卒業",
                        name: {month: `schlcrDetails[${i}].gradMon`, year: `schlcrDetails[${i}].gradYr`}
                      }, null, 8, ["max-year", "min-year", "name"])
                    ]),
                    _createElementVNode("div", _hoisted_32, [
                      _createVNode(ResumeSelect, {
                        "class-name": "p-recommend-form__select",
                        name: `schlcrDetails[${i}].gradFlg`,
                        id: "grad",
                        "empty-text": "選択"
                      }, null, 8, ["name"])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_33, [
                  _createElementVNode("button", {
                    class: "p-recommend-form__calendar-toggle",
                    type: "button",
                    onClick: _withModifiers(($event: any) => (openQuickViewModal(`schlcrDetails[${i}].gradYr`)), ["prevent"])
                  }, "卒業年早見表", 8, _hoisted_34)
                ])
              ]),
              _createElementVNode("button", {
                class: "p-recommend-form__delete-2",
                type: "button",
                onClick: ($event: any) => (removeSchl(i)),
                disabled: listSchls.value.length <= 1
              }, _hoisted_38, 8, _hoisted_35)
            ]))
          }), 128))
        ]),
        _createElementVNode("button", {
          class: "p-recommend-form__add --mt-2",
          type: "button",
          onClick: addSchl,
          disabled: listSchls.value.length >= MAX_SCHLS
        }, _hoisted_41, 8, _hoisted_39)
      ]),
      _createElementVNode("div", _hoisted_42, [
        _createElementVNode("a", {
          class: _normalizeClass(["p-recommend-form__send -is-prev", { 'active': __props.activeTab === 'workexperience' }]),
          href: "#workexperience",
          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_unref(switchTabAndValidateFn)!('#workexperience')), ["prevent"]))
        }, _hoisted_44, 2),
        _createElementVNode("a", {
          class: _normalizeClass(["p-recommend-form__send -is-next", { 'active': __props.activeTab === 'qualifications' }]),
          href: "#qualifications",
          onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_unref(switchTabAndValidateFn)!('#qualifications')), ["prevent"]))
        }, _hoisted_46, 2)
      ])
    ]),
    _createVNode(SchoolModal, {
      isOpen: isSchoolModalOpen.value,
      "onUpdate:isOpen": _cache[2] || (_cache[2] = ($event: any) => ((isSchoolModalOpen).value = $event))
    }, null, 8, ["isOpen"]),
    _createVNode(QuickViewModal, {
      "is-open": isQuickViewModalOpen.value,
      "onUpdate:is-open": _cache[3] || (_cache[3] = ($event: any) => ((isQuickViewModalOpen).value = $event)),
      onYearSelected: setYear
    }, null, 8, ["is-open"])
  ], 2))
}
}

})